export default {
  eyebrow: 'Portail partenaire',
  title: 'Facturation',
  description:
    'Votre moyen de paiement pour la facture mensuelle de la plateforme, et chaque facture avec son détail complet.',
  toasts: {
    checkout_error: 'Impossible de démarrer le paiement — veuillez réessayer.',
    action_error: "L'action a échoué — veuillez réessayer.",
    onboarding_error: 'Impossible de démarrer la vérification — veuillez réessayer.',
    payment_method_in_use:
      'Vos licences de restaurant sont facturées sur ce moyen de paiement, il ne peut donc pas être supprimé. Remplacez-le par un nouveau.',
  },
  payout_bank_account: {
    title: 'Compte bancaire de versement',
    description:
      'Les versements de la part de revenus sont effectués en {{currency}}. Stripe convertit le transfert à son arrivée.',
    toasts: {
      saved: 'Compte bancaire enregistré',
      save_failed: 'Impossible d’enregistrer le compte bancaire. Veuillez vérifier les informations.',
    },
  },
  payout_onboarding: {
    title: 'Configurez votre compte de versement',
    description:
      "Votre part de revenus est versée chaque mois sur un compte de versement Stripe. Effectuez la vérification une fois — les versements restent en attente tant qu'elle n'est pas terminée.",
    missing: {
      title: 'Encore nécessaire avant que les paiements puissent commencer :',
      bank_account: 'Ajoutez le compte bancaire sur lequel votre part de revenus doit être versée.',
      business_details:
        "Complétez les informations de votre entreprise, comme l'adresse, le numéro fiscal ou le numéro d'immatriculation.",
      people: 'Ajoutez les informations du représentant de votre entreprise, des propriétaires ou des dirigeants.',
      documents: 'Téléversez les documents de vérification demandés par Stripe.',
      terms: "Acceptez les conditions d'utilisation de Stripe.",
      other: 'Fournissez les informations restantes demandées par Stripe.',
    },
    start: 'Démarrer la vérification',
    continue: 'Poursuivre la vérification',
    ready:
      'Compte de versement vérifié — votre part de revenus est versée automatiquement après chaque cycle de facturation.',
  },
  payment_method: {
    title: 'Moyen de paiement',
    empty:
      'Aucun moyen de paiement enregistré — la facture mensuelle ne peut pas encore être prélevée automatiquement.',
    add: 'Ajouter un moyen de paiement',
    replace: 'Remplacer',
    remove: 'Supprimer',
    remove_confirm: {
      title: 'Supprimer ce moyen de paiement ?',
      description:
        'La carte/le mandat est détaché de Stripe immédiatement. Sans moyen de paiement, les factures — y compris celles déjà émises — sont recouvrées via la facture Stripe hébergée et non automatiquement.',
      confirm: 'Supprimer',
    },
  },
  invoices: {
    title: 'Factures',
  },
};
